class EnvironmentSettings {
  constructor() {
    if (window.location.href.includes("localhost")) {
      this.env = "development";
      this.LiveUrl = "https://localhost:5001/api/";
    } else if (window.location.href.toLowerCase().includes("staging")) {
      this.env = "development";
      this.LiveUrl = "https://medcoserver.tech:501/api/";
    } else {
      this.env = "production";
      this.LiveUrl = "https://medcoserver.tech/api/";
    }
  }
}

const env = new EnvironmentSettings();
export default env;
